import moment from 'moment-timezone';
import _ from 'lodash';
import {
  EntityTypes,
  countryList,
  zipCodeValidationMessage
} from './constants';

export const dateFormat = 'YYYY-MM-DD';

export const matchFieldByLabel = (fields = [], label) =>
  fields.find((f) => f.display_name === label);

export const toDaysOfYear = (date, timeZone) => {
  if(!timeZone) return moment(date).dayOfYear();
  return moment.tz(date, timeZone).dayOfYear();
};

export const sortByTime = (arr) => {
  const sorter = (a, b) => {
    return new Date(a.time).getTime() - new Date(b.time).getTime();
  };
  return arr.sort(sorter);
};
export const arrangeUniqTimeSlots = (timeSlots, providerId, timeZone) => {
  const times = timeSlots.map((x, index) => {
    return {
      index,
      time: moment.tz(x.startTime, timeZone).format('YYYY-MM-DDTHH:mm'),
      available: providerId
        ? x.entityId == providerId && x.entityType === EntityTypes.provider
        : true
    };
  });
  const removeUnavailable = times.filter(
    (t) => !t.available && times.some((x) => x.time === t.time && x.available)
  );
  const idsRemove = removeUnavailable.map((x) => x.index);
  const slotArrange = times.filter((item) => !idsRemove.includes(item.index));
  const uniqTimeSlot = _.uniqBy(slotArrange, 'time');
  return sortByTime(uniqTimeSlot);
};

export const filterTimeSlots = (timeSlots, entityType, entityIds) => {
  if (entityIds && entityIds.length > 0)
    return timeSlots.filter(
      (time) =>
        time.entityType == entityType && entityIds.includes(time.entityId)
    );
  if (!entityIds && entityType)
    return timeSlots.filter((time) => time.entityType == entityType);

  return [];
};
export const filterTimeSlotsByProviderLocation = (timeSlots, locationIds) => {
  if (timeSlots && locationIds)
    return timeSlots.filter(
      (time) =>
        time.entityType == EntityTypes.provider &&
        locationIds.includes(time.locationId)
    );

  return [];
};

export const sortProviders = (providers) => {
  if (!providers || !Array.isArray(providers)) {
    return [];
  }
  return providers.sort((a, b) => a.displayName.localeCompare(b.displayName));
};

export const countTimeSlots = (timeSlots) => {
  return timeSlots && timeSlots.length == 1
    ? timeSlots[0].length
    : timeSlots[0].length + timeSlots[1].length;
};

export const ConvertToAmPmTimeSlots = (fullDaytimeSlots) => {
  const amSlots = fullDaytimeSlots.filter(
    (slot) => moment(slot.time).hour() < 12
  );
  const pmSlots = fullDaytimeSlots.filter(
    (slot) => moment(slot.time).hour() >= 12
  );
  return [amSlots, pmSlots];
};

export const getZipCodeErrorValidationMessage = (country) => {
  return country === countryList.US
    ? zipCodeValidationMessage.US
    : zipCodeValidationMessage.CA;
};
export const sortLocations = (locations) => {
  if (!locations || !Array.isArray(locations)) {
    return [];
  }
  return locations.sort((a, b) => a.displayName.localeCompare(b.displayName));
};
export const sortLocationsByRadius = (locations) => {
  if (!locations || !Array.isArray(locations)) {
    return [];
  }
  return locations.sort((a, b) => a.radius - b.radius);
};
export const isTimeElapsed = (time, timeZone) => {
  return moment.tz(timeZone).diff(moment.tz(time, timeZone)) >= 0;
};
export const isAvailableSlot = (time, timeZone) => {
  return moment.tz(timeZone).diff(moment.tz(time, timeZone)) < 0;
};
